interface IntegerInputProps {
    id?: string,
    name?: string,

    className?: string,
    label?: string,
    value: number | undefined,
    valueMin?: number | undefined,
    valueMax?: number | undefined,
    setValue: (value: number) => void,

    disabled?: boolean,
}

const IntegerInput: React.FC<IntegerInputProps> = (props) => {
    function decrementa() {
        console.log('-');
        if (props.value) {
            let valid = props.valueMin ? props.value - 1 >= props.valueMin : true;
            if (valid)
                props.setValue(props.value - 1)
        }
    }

    function incrementa() {
        console.log('+');
        if (typeof props.value !== "undefined") {
            const value = (isNaN(props.value) || !props.value) ? 0 : props.value;
            let valid = props.valueMax ? value + 1 <= props.valueMax : true;
            if (valid)
                props.setValue(value + 1)
        }
    }

    const name = props.name ? props.name : undefined;
    const id = props.id ? props.id : name;
    return (
        <div className={props.className}>
            {props.label && <label htmlFor={props.id} className="block font-medium">
                {props.label}
            </label>}

            <div className="mt-1 flex rounded-md shadow-sm">
                <a className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm hover:cursor-default"
                   onClick={() => decrementa()}>
                    -
                </a>
                <input
                    type="text"
                    name={name}
                    id={id}
                    disabled={props.disabled}
                    className="block w-full min-w-0 flex-1 rounded-none border-gray-300 px-3 py-2 focus:border-blue-500 focus:ring-blue-500 sm:text-sm text-center"
                    value={props.value}
                    onChange={(e) => props.setValue(parseInt(e.target.value))}
                />
                <a className="inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm hover:cursor-default"
                   onClick={() => incrementa()}>
                    +
                </a>
            </div>
        </div>
    )
}
export default IntegerInput;